import { directoryApiClient, exchangeToken } from './auth'
import { setupTokenRefresh } from './tokenRefresh'
import { onUnauthenticated } from '../../utils/onUnauthenticated'

export const initTokenRefresh = (): void => {
  setupTokenRefresh(
    directoryApiClient,
    exchangeToken,
    onUnauthenticated,
  )
}
